export const CompanyEnum = Object.freeze({
  SCI: "SCI",
  GUI: "GUI",
  LDO: "LDO",
});

export const InvoiceTypeEnum = Object.freeze({
  MONTHLY: "monthly",
  CUSTOM: "custom",
});

export const SingleInvoiceStatusEnum = Object.freeze({
  ACCURATE: "accurate",
  WITH_CHANGES: "with-changes",
  ARCHIVED: "archived",
});

export const ProductSelectionEnum = Object.freeze({
  ALL_PRODUCTS: "all-products",
  DIESEL: "diesel",
  GAS91: "gas91",
  GAS95: "gas95",
  GAS97: "gas97",
  NON_FUEL: "non-fuel",
});

